// This component provides additional
// functionality to videos

// Note that there is an additional part to
// add/remove classes to video containers
// that are within carousels
// See src/resources/scripts/components/Slick.js

class VideoContainer {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._button = elem.querySelector('.icon--button')
        this._video = elem.querySelector('video')
    }
    onInit () {
        if (this._button) {
            this._button.addEventListener('click', (event) => {
                if (this._elem && this._elem.classList.contains('video-container--paused')) {
                    this._video.play()
                    this._elem.classList.remove('video-container--paused')
                } else {
                    this._video.pause()
                    this._elem.classList.add('video-container--paused')
                }
            })

            this._video.addEventListener('ended', (event) => {
                this._button.classList.add('video-container--paused')
            })
        }
    }
}

export default VideoContainer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VideoContainer.js